interface AuthUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  telephone?: string;
  role: "ADMIN" | "EMPLOYEE";
  gender?: string;
  language?: string;
  companyID?: string;
  companyName?: string;
  subscription?: string;
  token?: string;
}

export function getAuthUser(): AuthUser | undefined {
  const raw = localStorage.getItem("authUser");
  if (!raw) return undefined;

  try {
    const parsed = JSON.parse(raw);

    if (!parsed || typeof parsed !== "object") {
      localStorage.removeItem("authUser");
      return undefined;
    }

    return parsed as AuthUser;
  } catch (error) {
    localStorage.removeItem("authUser");
    return undefined;
  }
}
